import script from "./ReviewMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewMapping.vue?vue&type=script&setup=true&lang=js"

import "./ReviewMapping.vue?vue&type=style&index=0&id=aee97c2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aee97c2a"]])

export default __exports__